module.exports = __webpack_public_path__ + "img/2185.70dea13f.gif";